import { BusinessGraphV1Schema } from "./business-graph.js";
/**
 * Top-level keys that must never appear in website-facing BusinessGraph JSON
 * (GenerationRun ledger, ClientOps private ops, internal trace payloads).
 */
export const BUSINESS_GRAPH_FORBIDDEN_TOP_LEVEL_KEYS = [
    "runId",
    "generationRun",
    "generationJob",
    "generationJobEnqueue",
    "qualityGateResult",
    "qaGatedStatus",
    "exportBundleHash",
    "artifactSetHash",
    "traceJson",
    "clientOps",
    "opsFeed",
    "privateJobFields",
    "idempotencyRecord",
    "latestPassingArtifact",
    "tenantProjectRevision",
    "correlationId",
    "traceId",
    "internalReportJson",
];
const FORBIDDEN_TOP_LEVEL = new Set(BUSINESS_GRAPH_FORBIDDEN_TOP_LEVEL_KEYS);
function isPlainObject(value) {
    return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}
/**
 * Deep-removes forbidden top-level keys anywhere in a JSON tree
 * (e.g. nested `clientOps` objects injected beside contract fields).
 */
export function stripForbiddenBusinessGraphFields(value) {
    if (Array.isArray(value)) {
        return value.map((item) => stripForbiddenBusinessGraphFields(item));
    }
    if (!isPlainObject(value)) {
        return value;
    }
    const out = {};
    for (const [key, child] of Object.entries(value)) {
        if (FORBIDDEN_TOP_LEVEL.has(key)) {
            continue;
        }
        out[key] = stripForbiddenBusinessGraphFields(child);
    }
    return out;
}
/** Parse after strip — canonical website-safe BusinessGraph for persist/export/map. */
export function parseBusinessGraphWebsiteSafe(value) {
    const stripped = stripForbiddenBusinessGraphFields(value);
    return BusinessGraphV1Schema.parse(stripped);
}
/** Re-assert an in-memory graph is website-safe (strip + strict re-parse). */
export function assertBusinessGraphWebsiteSafe(graph) {
    return parseBusinessGraphWebsiteSafe(graph);
}
/** Returns true when serialized JSON would not contain forbidden top-level keys. */
export function businessGraphJsonIsWebsiteSafe(value) {
    const stripped = stripForbiddenBusinessGraphFields(value);
    if (!isPlainObject(stripped)) {
        return false;
    }
    for (const key of Object.keys(stripped)) {
        if (FORBIDDEN_TOP_LEVEL.has(key)) {
            return false;
        }
    }
    return BusinessGraphV1Schema.safeParse(stripped).success;
}
//# sourceMappingURL=business-graph-website-safe.js.map